const isIntegration = () => {
  return /test\./.test(window.location.host)
}

export default isIntegration
